import { configureStore } from '@reduxjs/toolkit'

import menuSlice        from './components/menu/menuSlice';
import dashboardSlice   from './components/dashboard/dashboardSlice';
import settingsSlice    from './components/settings/settingsSlice';
import searchSlice      from './components/search/searchSlice';
import objectSlice      from './components/object/objectSlice';
import textSlice        from './components/object/textSlice';
import mediaSlice       from './components/object/mediaSlice';
import contractSlice    from './components/contract/contractSlice';
import appSlice         from './appSlice';

export default configureStore({
  reducer: {
    app:        appSlice,
    menu:       menuSlice,
    search:     searchSlice,
    dashboard:  dashboardSlice,
    settings:   settingsSlice,
    object:     objectSlice,
    text:       textSlice,
    media:      mediaSlice,
    contract:   contractSlice
  },
})